<template>
<v-card>
  <request-status :request='requests.validate' />

  <v-card-title
    v-if="properties && properties.id"
    class='subtitle-1 grey lighten-4 py-1' >
    Validating {{ properties.title }}
    <v-btn :href="`https://www.jotform.com/build/${formId}`" target="_blank" flat small icon >
      <v-icon small >open_in_new</v-icon></v-btn>
    <v-spacer/>
    <v-btn icon small @click="$emit('close', formId)" >
      <v-icon icon small>close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>
  <v-card-text v-if='formId' >

      <form-checks
        v-if="properties && properties.id"
        :has-relationship-id="hasRelationshipId"
        :webhook-key="webhookKey"
        :properties="properties" />

      <v-divider/>

      <v-subheader class="overline" >
        <!-- <v-icon small class="mr-2" >check</v-icon> -->
        Select fields which you would like to link to values in AppointmentGuru
      </v-subheader>

      <v-alert :value="showRefreshNotice" type="info" dismissible >
        <strong>Important</strong> If you have this form open in JotForm you must refresh the page for changes to reflect
      </v-alert>

      <!-- {{questions}} -->
      <v-card class="grey lighten-3" >
        <v-card-text class="py-1" >
          Map your form fields to your client's AppointmentGuru profile</v-card-text>
        <v-divider/>

        <v-card-text >
          <v-layout >
            <v-flex xs5 >
              <v-subheader class="overline" >Field in AppointmentGuru</v-subheader>
            </v-flex>
            <v-flex xs5 >
              <v-subheader class="overline" >Field in form</v-subheader>
            </v-flex>
            <v-flex xs2 ></v-flex>
          </v-layout>
          <template >
            <v-card class="mt-1" >
              <v-layout>
                <v-flex xs6 class="pl-3 pt-2" >
                  <select placeholder="Choose a field in AppointmentGuru"
                    v-model="agField"
                    style='border:solid 1px #ccc;padding:2px;margin-top:0px;width:90%;'
                    class='mr-2' >
                    <option selected disabled >Choose a field in AppointmentGuru</option>
                    <option
                      v-for="field in unmappedFields"
                      :disabled="field.startsWith('-- ')"
                      :value="field"
                      :key='field' >
                      {{field}}
                    </option>
                  </select>
                </v-flex>
                <v-flex xs6 >
                  <select
                    v-model="jfField"
                    style='border:solid 1px #ccc;padding:2px;margin-top:7px;width:90%;' class='mr-2' >
                    <option selected disabled >Choose a field from your form</option>
                    <template v-for="question in questions" >
                      <template v-if="!isHiddenJotFormFieldType(question)" >
                        <option v-if="isDisabledJotFormFieldType(question) !== false"
                          disabled
                          :key='question.qid' >
                          <!-- [{{question.qid}}] -->
                          {{ isDisabledJotFormFieldType(question) }}
                          <!-- ({{question.order}}) -->
                        </option>
                        <option v-else
                          :value="question.qid"
                          :key='question.qid' >
                          <!-- [{{question.qid}}] -->
                          <!-- {{question.name}} - -->
                          <span v-if="question.type === 'control_radio'" >()</span>
                          <span v-if="question.type === 'control_checkbox'" >[]</span>
                          {{question.text}}
                          <span v-if="question.required === 'Yes'" >*</span>
                          <span v-if="question.hidden === 'Yes'" >(hidden)</span>
                          <!-- ({{question.order}}) -->
                        </option>
                      </template>
                    </template>
                  </select>
                </v-flex>
                <v-flex xs2 class="pr-2" >
                  <v-btn small block outline
                    @click="saveQuestion"
                    :loading="requests.savequestion.loading"
                    color="primary" >Save</v-btn>
                </v-flex>
              </v-layout>

            </v-card>
          </template>
        </v-card-text>
      </v-card>

      <v-subheader class="overline" >These fields are mapped</v-subheader>
      <template v-for="field in mappedFields" >
        <v-list-tile :key='field.id' >
          <!-- <v-list-tile-avatar >
            <v-icon>check</v-icon>
          </v-list-tile-avatar> -->
          <v-list-tile-content>
            <v-list-tile-title style="height:30px;line-height:30px;" >
              <v-chip small >
                <v-avatar >
                  <img :src="jotformIcon" left />
                </v-avatar>
                <span v-if="field.required==='Yes'" class="mr-1" >*</span>
                {{field.text}}
              </v-chip>

              <v-chip small flat class='white' >
                <v-icon >arrow_right_alt</v-icon>
              </v-chip>

              <v-chip small >
                <v-avatar >
                  <img :src="agIcon" left />
                </v-avatar>
                {{field.id}}
              </v-chip>

            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="field.required!=='Yes'" >
            <v-btn flat small
              :disabled="requests.savequestion.loading"
              @click="requireQuestion(field)" >Make required</v-btn>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn flat small
              :disabled="requests.savequestion.loading"
              @click="unmap(field)" >Unlink</v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <!-- <v-divider :key='`d-${field.id}`' /> -->
        <!-- <pre v-text="field" :key='`d-${field.id}`' /> -->
      </template>

    </v-list>
    <!-- {{requests.validate.result}} -->
  </v-card-text>
  <v-card-actions>
    <v-btn @click="$emit('close', formId)" >Done</v-btn>
    <v-spacer/>
    <v-btn @click="refresh" color="primary" >Revalidate form</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import FormChecks from './FormChecks.vue'

export default {
  name: 'ValidateForm',
  components: { FormChecks },
  props: {
    formId: { required: true },
    webhookKey: { type: String, required: true }
  },
  data () {
    return {
      agField: null,
      jfField: null,
      showRefreshNotice: false,
      requests: {
        validate: {
          resource: 'ag.integrations',
          extra: 'jotform/validate',
          method: 'post'
        },
        questions: {
          resource: 'ag.integrations',
          extra: 'jotform/questions',
          method: 'post'
        },
        savequestion: {
          resource: 'ag.integrations',
          extra: 'jotform/questions',
          method: 'post'
        }
      }
    }
  },
  watch: {
    formId: {
      immediate: true,
      handler () {
        this.refresh()
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.validate()
        this.agField = null
        this.jfField = null
        this.showRefreshNotice = true
      }
    }
  },
  computed: {
    mappedFields () {
      return this.getObjectPath(this.requests.validate, 'result.mapped_fields', [])
    },
    unmappedFields () {
      return this.getObjectPath(this.requests.validate, 'result.unmapped_fields', [])
    },
    hasRelationshipId () {
      return (this.unmappedFields.indexOf('relationship_id') === -1)
    },
    questions () {
      let qq = this.getObjectPath(this.requests.questions, 'result.content')
      if (qq) {
        qq = Object.values(qq)
        return qq.sort((a, b) => {
          if (parseInt(a.order) > parseInt(b.order)) { return 1 }
          if (parseInt(b.order) > parseInt(a.order)) { return -1 }
          return 0
        })
      }
      return []
    },
    properties () {
      return this.getObjectPath(this.requests.validate, 'result.properties', {})
    },
    saveRequestStatus () {
      return this.requests.savequestion.status
    },
    jotformIcon () {
      // let url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-white-560x560.png'
      let url = 'https://ik.imagekit.io/appointmentguru/partners/jotform/jotform-icon-dark-800x800.png'
      return this.imageKitUrl(url, 'n-avatar')
    },
    agIcon () {
      let url = 'https://ik.imagekit.io/appointmentguru/brand/practitioner_icon_1024x1024.png'
      return this.imageKitUrl(url, 'n-avatar')
    }
  },
  methods: {
    refresh () {
      this.validate()
      this.getQuestions()
    },
    validate () {
      this.requests.validate.params = { form_id: this.formId }
      this.$request('get', this.requests.validate)
    },
    getQuestions () {
      this.requests.questions.params = { form_id: this.formId }
      this.$request('get', this.requests.questions)
    },
    unmap (field) {
      this.requests.savequestion.params = { form_id: this.formId }
      this.requests.savequestion.data = {
        'qid': field.qid,
        'property': 'name',
        'value': field.id + '-' + field.qid
      }
      this.requests.savequestion.method = 'post'
      this.$request('save', this.requests.savequestion)
    },
    requireQuestion (field) {
      this.requests.savequestion.params = { form_id: this.formId }
      this.requests.savequestion.data = {
        'qid': field.qid,
        'property': 'required',
        'value': 'Yes'
      }
      this.requests.savequestion.method = 'post'
      this.$request('save', this.requests.savequestion)
    },
    saveQuestion () {
      this.requests.savequestion.params = { form_id: this.formId }
      this.requests.savequestion.data = {
        'qid': this.jfField,
        'property': 'name',
        'value': this.agField
      }
      this.requests.savequestion.method = 'post'
      this.$request('save', this.requests.savequestion)
    },
    isHiddenJotFormFieldType (field) {
      let hiddenFields = ['control_text', 'control_button', 'control_image']
      return (hiddenFields.indexOf(field.type) !== -1)
    },
    isDisabledJotFormFieldType (field) {
      let disabledTypes = ['control_head', 'control_divider', 'control_pagebreak']
      if (disabledTypes.indexOf(field.type) === -1) { return false }

      // special cases
      if (field.type === 'control_head') { return '##' + field.text }
      if (field.type === 'control_divider') { return '----' }
      if (field.type === 'control_pagebreak') { return '----' }
      return field.text
    }
  }
}
</script>



// WEBPACK FOOTER //
// ValidateForm.vue?6363f733